.top-runners {
  margin: 0 auto;
  padding: 8px 0 24px;
  background-color: #f7f7f7;
  box-sizing: border-box;
}

.top-runners *,
.top-runners *::before,
.top-runners *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .top-runners {
    margin: 0;
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }
}

.top-runners__slider {
  width: 100%;
}

:host(:not([dir="rtl"])) .top-runners__slider {
  padding: 0 0 12px 24px;
}

:host([dir="rtl"]) .top-runners__slider {
  padding: 0 24px 12px 0;
}

@media screen and (min-width: 980px) {
  .top-runners__card {
    width: 33.3%;
    height: 300px;
    padding: 10px;
  }
}

@media screen and (min-width: 980px) {
  .top-runners__card--large {
    width: 66.6%;
    max-width: 650px;
  }
}